import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from "@angular/router";

// Services
import { SharedService } from 'src/app/services/shared.service';
import { LoginService } from 'src/app/services/login/login.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { AmplitudeService } from 'src/app/services/amplitude.service';

import { Address } from 'src/app/models/address';

// Maps
import { } from 'googlemaps';
import toastr from "toastr";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {

  showLogin: boolean = false;

  optionsMap: any;
  mapLocation: any;
  markerLocation: any;
  geocoder: any;
  latitude: number = 4.6097100;
  longitude: number = -74.0817500;

  listIndicatives: any[];
  indicativeSelected: string = '57';
  statusSelectIndicative: boolean = false;

  numberPhone: string = '';
  phoneValid: boolean = false;

  optSelected: number = 1;

  // codigo
  code1: string = '';
  code2: string = '';
  code3: string = '';
  code4: string = '';
  code5: string = '';
  codeValid: number = 1;
  resendCode: number = 60;

  loading: boolean = false;

  // direcciones
  listAddress: Address[] = [];
  addressSearch: string = '';
  nameAddress: string = '';
  descriptionAddress: string = '';

  // Registro
  userName: string = '';

  termsAndConditions: boolean = false;

  constructor(
    private _sharedService: SharedService,
    private _loginService: LoginService,
    private _profileService: ProfileService,
    private _amplitudeService: AmplitudeService,
    private _router: Router,
  ) {
    this.listIndicatives = this._sharedService.getListIndicatives();
    this.optionsMap = this._sharedService.getoptionsMap();
  }

  ngOnInit(): void {
    this._amplitudeService.emmiterLogEvent('OPEN_LOGIN', {});
    this.initMapGs();
  }

  initMapGs(): void {
    this.optionsMap.center = { lat: this.latitude, lng: this.longitude };
    this.optionsMap.zoom = 13;
    let map: any = document.getElementById('map');
    if (map) this.mapLocation = new google.maps.Map(map, this.optionsMap);
    else console.log('No se pudo cargar el mapa');
    this.createMarker();
    // this.markerLocation = new google.maps.Marker({position: this.optionsMap.center, map: map});
    // setTimeout(() => this.markerLocation.setMap(this.mapLocation), 200);
  }

  createMarker(): void {
    this.markerLocation = new google.maps.Marker({
      position: new google.maps.LatLng(this.latitude, this.longitude),
      draggable: true,
      animation: google.maps.Animation.DROP,
      map: this.mapLocation
    });
    this.markerLocation.addListener('dragend', (e: any) => this.handleEvent2(e));
  }

  handleEvent2(e: any) {
    this.latitude = e.latLng.lat();
    this.longitude = e.latLng.lng();
  }

  zoomIn(): void {
    this.optionsMap.zoom++
    this.mapLocation.setZoom(this.optionsMap.zoom)
  }

  zoomOut(): void {
    this.optionsMap.zoom--
    this.mapLocation.setZoom(this.optionsMap.zoom)
  }

  selectOpt(opt: number): void {
    this.optSelected = opt;
    switch(opt){
      case 4:{
        
        break;
      }
    }
  }

  // List Address
  async getAddress() {
    this.loading = true;
    let userId = localStorage.getItem('uid')
    let response: any = await this._loginService.getAddress(userId).toPromise()
      .catch((err: any) => {
        toastr.warning('No se pudieron obtener las direcciones.');
        console.log(err);
      });
      
    if( response && response.data && response.data.direcciones ){
      this.listAddress = new Address().mapAddress(response.data.direcciones);
      if(this.listAddress.length != 0) this.selectOpt(4)
      else  this.selectOpt(5);
      this.loading = false;
    }else{
      this.selectOpt(5);
    }
  }

  selectAddress(address: Address): void {
    localStorage.setItem('latitude', address.latitude);
    localStorage.setItem('longitude', address.longitude);
    this.updateAddress(address);
    this.closeLogin();
  }

   // Actualizar Direccion
   async updateAddress(address: Address) {
    let data = {
      address_id: address.id,
      address_name: address.name
    }
    address.selected = true;
    let response: any = await this._profileService.updateName(data).toPromise()
      .catch((err: any) => {
        console.log('Error al actualizar nombre de usuario.');
      });
    address.selected = false;
    if( response ){
      console.log(response);
    }
  }

  async deleteAddress(addressId: string) {
    this.loading = true;
    let response: any = await this._loginService.deleteAddress(addressId).toPromise()
      .catch((err: any) => {
        toastr.warning('No se pudo eliminar la dirección.');
        console.log(err);
      });
      console.log('------>', response);
      
    if( response  ){
      this.getAddress();
      this.loading = false;
    }else{

    }
  }

  // Agregar direccion
  changeTextAddress(): void {
    this.geocoder = new google.maps.Geocoder();
    this.optionsMap.zoom = 15;
    this.optionsMap.gestureHandling = 'greedy';
    this.geocoder.geocode({ 'address':  this.addressSearch }, (results: any, status: any) => {
      if (status == 'OK') {
        this.mapLocation.setCenter(results[0].geometry.location);
        this.setMarker(results[0].geometry.location);
      } else {
        console.log('no se encontro la ubicación');
      }
    });
  }

  setMarker(geometryLocation: any): void {
    let lat = geometryLocation.lat();
    let lng = geometryLocation.lng();
    this.latitude  = lat;
    this.longitude = lng;
    let LatLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
    this.markerLocation.setPosition(LatLng);
  }

  async createAddress() {
    if(this.validFormCreateAddress()){
      this.loading = true;
      let data = {
        name: this.nameAddress,
        description: this.descriptionAddress,
        address : this.addressSearch,
        latitude : this.latitude.toString(),
        longitude : this.longitude.toString(),
        priority : "1"
      };
      let response: any = await this._loginService.createAddress(data).toPromise()
        .catch((err: any) => {
          toastr.warning('No se pudo crear la dirección');
          console.log('Error al crear direccion: ', err);
        })
      if( response ){
        console.log(response);
        localStorage.setItem('latitude', this.latitude.toString());
        localStorage.setItem('longitude', this.longitude.toString());
        this._loginService.emmiterShowLogin(false);
        this.loading = false;
      }
    }else toastr.warning('Todos los campos son requeridos.');
  }
 
  validFormCreateAddress(): boolean {
    if(this.nameAddress == '') return false;
    if(this.addressSearch == '') return false;
    return true;
  }

  // Login
  showIndicatives(): void {
    let widthContainer = document.getElementsByClassName('container-input-indicative')[0].clientWidth;
    let list: any =  document.getElementsByClassName('list-indicatives')[0];
    list.style.width = widthContainer + 'px';
    this.statusSelectIndicative = true;
  }

  selectIndicative(indicative: string): void{
    this.indicativeSelected = indicative;
    this.statusSelectIndicative = false;
  }

  validateOnlyNumbers(): void {
    if(
      this._sharedService.validateOnlyNumbers(this.numberPhone) &&
      this.numberPhone.length > 7
      ){
      this.phoneValid = true;
    }else this.phoneValid = false;
    
  }
  
  async login() {
    this.codeValid = 3;
    let data = {
      phone_code: '+' + this.indicativeSelected,
      user: this.numberPhone,
      password: `${this.code1}${this.code2}${this.code3}${this.code4}${this.code5}`
    };
    let response: any = await this._loginService.loginUser(data).toPromise()
    .catch((err: any) => {
      this.codeValid = 2;
      if(err.error.message) {
        this._amplitudeService.emmiterLogEvent('FAIL_LOGIN', {
          MESSAGE: err.error.message
        });
        toastr.warning(err.error.message);
      } else this._amplitudeService.emmiterLogEvent('FAIL_LOGIN', {});
    });
    if( response && response.data && response.data.session ){
      console.log(response);
      localStorage.setItem('uid',        response.data.session.user_id)
      localStorage.setItem('token',      response.data.session.token)
      localStorage.setItem('user_phone', `+${this.indicativeSelected}${this.numberPhone}`)
      localStorage.setItem('session','true')
      this._loginService.emmiterLoginSuccess(true);
      this._amplitudeService.initAmplitude();
      this._amplitudeService.emmiterLogEvent('SUCCESS_LOGIN', {
        'USER_PHONE': this.numberPhone
      });
      this.codeValid = 2;
      // this.validateAddressTem();
      // ABRIR MODULO PARA SELECCIONAR DIRECCION
      // this.getAddress();
      this.closeLogin();
    }
  }

  validateAddressTem(): void {
    if (localStorage.getItem('user_address')) {
      toastr.warning('Guarda tu dirección para que puedas hacer pedidos.');
      this._router.navigate(['ubicacion/crear/empresa']);
    } else {
      // let place_id = localStorage.getItem('place_id')
      // if (place_id != null && place_id != 'null' && place_id != undefined)
      //   this._router.navigate([`/domicilios/empresa/${place_id}`]);
    }
  }

  // Registro
  async getSmsCode() {
    if (this.termsAndConditions) {
      this.loading = true;
      let data = {
        phone_code: '+' + this.indicativeSelected,
        user: this.numberPhone
      };
      let response: any = await this._loginService.getSmsCode(data).toPromise().catch((err: any) => this.handleError(err));
      if( response ){
        this._amplitudeService.emmiterLogEvent('SUCCESS_SMS_CODE_GENERATED', {});
        console.log(response);
        this.optSelected = 3;
        this.loading = false;
        this.countdown();
      }
    } else toastr.warning('Debe aceptar los términos y condiciones.');
  }

  async getCode() {
    if (this.termsAndConditions) {
      this.loading = true;
      let data = {
        phone_code: '+' + this.indicativeSelected,
        user: this.numberPhone
      };
      let response: any = await this._loginService.getCode(data).toPromise().catch((err: any) => this.handleError(err));
      if( response ){
        this._amplitudeService.emmiterLogEvent('SUCCESS_CODE_GENERATED', {});
        console.log(response);
        this.optSelected = 3;
        this.loading = false;
        this.countdown();
      }
    } else toastr.warning('Debe aceptar los términos y condiciones.');
  }
  
  handleError(error: HttpErrorResponse): void {
    if(error.error.message) console.log(error.error.message);
    if(error.status == 404) {
      this._amplitudeService.emmiterLogEvent('UNREGISTERED_USER', {});
      this.selectOpt(2);
    }
    this.loading = false;
  }
  
  async registerUser() {
    if(this.userName != ''){
      this.loading = true;
      let data = {
        phone_code: '+' + this.indicativeSelected,
        phone: this.numberPhone,
        name: this.userName
      };
      let response: any = await this._loginService.registerUser(data).toPromise()
      .catch((err: any) => {
        this._amplitudeService.emmiterLogEvent('FAIL_REGISTERED_USER', {});
        console.log('Error al registrar', err);
      });
      if( response ){
        this.loading = false;
        this._amplitudeService.emmiterLogEvent('SUCCESS_REGISTERED_USER', {});
        this.getCode();
      }
    } else toastr.warning('Ingrese un nombre valido');
  }


  // Codigo
  changeCode(): void {
    this.code1 = this.code1.substr(0,1);
    this.code2 = this.code2.substr(0,1);
    this.code3 = this.code3.substr(0,1);
    this.code4 = this.code4.substr(0,1);
    this.code5 = this.code5.substr(0,1);
    if(this.code1 != '' && this.code2 != '' && this.code3 != '' && this.code4 != '' && this.code5 != '' ) this.codeValid = 2;
    else this.codeValid = 1;
  }

  keyUp(id ?: any): void {

    this.code1 = this.code1.substr(0,1);
    this.code2 = this.code2.substr(0,1);
    this.code3 = this.code3.substr(0,1);
    this.code4 = this.code4.substr(0,1);
    this.code5 = this.code5.substr(0,1);

    if(this.code1 != '' && this.code2 != '' && this.code3 != '' && this.code4 != '' && this.code5 != '' ) this.codeValid = 2;
    else this.codeValid = 1;

    let inputCodeSix = (document.getElementById('code5') as HTMLInputElement);
    if(id == null || id == undefined){
      if(inputCodeSix.value.length > 1 ) inputCodeSix.value = inputCodeSix.value.charAt(1);
    }else{
      (document.getElementById(id) as HTMLInputElement).select();
      (document.getElementById(id) as HTMLInputElement).focus();
    }
  }

  countdown(): void {
    this.resendCode = 60;
    let interval = setInterval(() => {
      this.resendCode --;
      if(this.resendCode == 0) clearInterval(interval);
    } , 1000);
  }

  closeLogin(): void {
    this._amplitudeService.emmiterLogEvent('CLOSE_LOGIN', {});
    this._loginService.emmiterShowLogin(false);
  }

  openTermsAndConditions(): void {
    let urlSiteIt = 'http://siteit.co/tyc.html';
    let urlBuffalo = 'https://as-siteitfoods-prod.azurewebsites.net/assets/pdfs/POLITICA-DE-TRATAMIENTO-DE-DATOS-PERSONALES-OFC-2018.pdf';
    this._amplitudeService.emmiterLogEvent('OPEN_TERMS_AND_CONDITIONS', {
      URL: urlSiteIt 
    });
    window.open(
      urlBuffalo,
      '_blank'
    );
    window.open(
      urlSiteIt,
      '_blank'
    );
  }
}
